import React from "react";
import { Col, Form, InputGroup, Row } from "react-bootstrap";

type EventStreamFiltersProps = {
    availableEventTypes: string[];
    selectedEventType: string;
    userIdFilter: string;
    onChange: (eventType: string, userId: string) => void;
    onClear: () => void;
}

const EventStreamFilters: React.FC<EventStreamFiltersProps> = ({
    availableEventTypes,
    selectedEventType,
    userIdFilter,
    onChange,
    onClear
}) => {
    const handleEventTypeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(e.currentTarget.value, userIdFilter);
    };

    const handleUserIdChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(selectedEventType, e.currentTarget.value);
    };

    return (
        <Row className="align-items-center" style={{ marginBottom: "10px" }}>
            <Col md="auto">
                <InputGroup size="sm">
                    <InputGroup.Prepend>
                        <InputGroup.Text>Event Type</InputGroup.Text>
                    </InputGroup.Prepend>
                    <Form.Control
                        as="select"
                        value={selectedEventType}
                        onChange={handleEventTypeChange}
                        style={{ minWidth: "160px" }}
                    >
                        <option value="">All</option>
                        {availableEventTypes.map(et => (
                            <option key={et} value={et}>{et}</option>
                        ))}
                    </Form.Control>
                </InputGroup>
            </Col>
            <Col md="auto">
                <InputGroup size="sm">
                    <InputGroup.Prepend>
                        <InputGroup.Text>User ID</InputGroup.Text>
                    </InputGroup.Prepend>
                    <Form.Control
                        type="text"
                        placeholder="Filter by user ID…"
                        value={userIdFilter}
                        onChange={handleUserIdChange}
                        style={{ minWidth: "200px" }}
                    />
                </InputGroup>
            </Col>
        </Row>
    );
};

export default EventStreamFilters;
